
/* PDP HEADING, PRICE, FLAIR BADGE - RELOCATION for MOBILE */
/* Move the PDP title and info above image on mobile */
     let wasMoved = null;

    function productHeadingMove(){
     let viewportWidth = window.innerWidth; 
     let mHeading = document.querySelector('.product-block--header');
     let mPrice = document.querySelector('.product-block--price');
     let mFlair = document.querySelector('.page-content--product flair-banners'); /* this is the position on desktop */ 
     let mFlair2 = document.querySelectorAll('.page-content--product .flair-sitewide-banner'); /* this is the position on mobile */ 
     let abovePhoto = document.querySelector('.page-content--product .grid');
     let rightOfPhoto = document.querySelector('.product-single__meta');
     let pBlock = document.querySelector('.product-block--header');
     

  if (viewportWidth <= "639"){
     wasMoved = true;
     abovePhoto.prepend(mHeading, mFlair, mPrice);
     abovePhoto.style.textAlign="center";
     pBlock.style.marginBottom = "0px";
     //mPrice.style.marginTop = "-20px";
     document.querySelector('.product-block').style.marginBottom = "0px";
     mFlair2.style.display = "block!important";
     mFlair2.style.border = "solid 1px red";

   } else if(viewportWidth >= "640" && wasMoved == true){
   /* Let's put it back if on desktop */
    wasMoved = null;
    rightOfPhoto.prepend(mHeading, mFlair, mPrice);
    rightOfPhoto.style.textAlign="left";
    pBlock.style.marginBottom = "0px";
    mPrice.style.marginTop = "0px";
     mFlair.style.display = "flex!important";
    //document.querySelector('.product-block').style.marginBottom = "25px";
   
   }
};
productHeadingMove();
window.addEventListener('resize', productHeadingMove);
/* EOF */
